import Vue from 'vue'
import VueRouter from 'vue-router'
// import App from './components/App.vue'
import AsnHeader from './components/AsnHeader.vue'
import AsnFooter from './components/AsnFooter.vue'
import Loading from './components/Loading.vue'
import Tooltip from './components/Tooltip.vue'

// 共通画面
import Login from './components/common/Login.vue'
import ResetPassword from './components/common/ResetPassword.vue'
import SignUp from './components/common/SignUp.vue'
import UserWorkRegistrationNewEdit from './components/common/user/UserWorkRegistrationNewEdit.vue'
import UserWorkRegistrationView from './components/common/user/UserWorkRegistrationView.vue'
import PageNotFound from './components/404.vue'

// @manage管理画面
import CompanyList from './components/atmanage/company/CompanyList.vue'
import CompanyReportList from './components/atmanage/company/CompanyReportList.vue'

// 企業管理画面
import AdminTop from './components/admin/AdminTop.vue'
import Config from './components/admin/config/Config.vue'
import ConfigCompany from './components/admin/config/ConfigCompany.vue'
import ConfigCard from './components/admin/config/ConfigCard.vue'
import ConfigDelete from './components/admin/config/ConfigDelete.vue'
import ConfigSignOut from './components/admin/config/ConfigSignOut.vue'
import DepartmentList from './components/admin/user/DepartmentList.vue'
import DepartmentNewEdit from './components/admin/user/DepartmentNewEdit.vue'
import KotsuhiList from './components/admin/kotsuhi/KotsuhiList.vue'
import UserList from './components/admin/user/UserList.vue'
import UserNewEdit from './components/admin/user/UserNewEdit.vue'
import WorkMonthlySummary from './components/admin/work/WorkMonthlySummary.vue'
import WorkDetail from './components/admin/work/WorkDetail.vue'
import WorkDetailEdit from './components/admin/work/WorkDetailEdit.vue'
import WorkAnnuallySummary from './components/admin/work/WorkAnnuallySummary.vue'
import WorkShiftManage from './components/admin/work/WorkShiftManage.vue'
import WorkSchedule from './components/admin/work/WorkScheduleManage.vue'
import YukyuList from './components/admin/yukyu/YukyuList.vue'
import YukyuManagement from './components/admin/yukyu/YukyuManagement.vue'
import YukyuControlBook from './components/admin/yukyu/YukyuControlBook.vue'
import SpLeave from './components/admin/yukyu/SpLeave.vue'

// オペレータ画面
import Calendar from './components/operator/Calendar.vue'
import OpeSetting from './components/operator/Setting.vue'
import Work from './components/operator/work/Work.vue'
import WorkEdit from './components/operator/work/WorkEdit.vue'
import KotsuhiHistory from './components/operator/kotsuhi/KotsuhiHistory.vue'
import KotsuhiUnpaidList from './components/operator/kotsuhi/KotsuhiUnpaidList.vue'
import LeaveRequestHistory from './components/operator/leave_request/LeaveRequestHistory.vue'

/**
 * ElementUI
 */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
Vue.use(ElementUI, {locale})

/**
 * ルータ
 */
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes: [
    // { path: '/', component: App },
    { path: '/', component: Login },
    { path: '/login', component: Login },
    { path: '/reset-password', component: ResetPassword },
    { path: '/sign-up', component: SignUp },
    { path: '/user-work-registration', component: UserWorkRegistrationView },

    // @manage管理画面
    { path: '/atmanage/top', component: CompanyList },
    { path: '/atmanage/company/top', component: CompanyList },
    { path: '/atmanage/company/report/:companyId', component: CompanyReportList },

    // 企業管理画面
    { path: '/admin/top', component: AdminTop },
    { path: '/admin/leave-request/top', component: YukyuList },
    { path: '/admin/yukyu/management', component: YukyuManagement },
    { path: '/admin/yukyu/sp-leave', component: SpLeave },
    { path: '/admin/yukyu/controlbook', component: YukyuControlBook },
    { path: '/admin/kotsuhi/top', component: KotsuhiList },
    { path: '/admin/work/top', component: WorkMonthlySummary },
    { path: '/admin/work/detail/:userId', component: WorkDetail },
    { path: '/admin/work/edit/:targetDate/:userId', component: WorkDetailEdit },
    { path: '/admin/work/annually-summary', component: WorkAnnuallySummary },
    { path: '/admin/work/shift/top', component: WorkShiftManage },
    { path: '/admin/work/schedule/top', component: WorkSchedule },
    { path: '/admin/user/top', component: UserList },
    { path: '/admin/user/new', component: UserNewEdit },
    { path: '/admin/user/edit/:id', component: UserNewEdit },
    { path: '/admin/user/work-registration/edit/:userId', component: UserWorkRegistrationNewEdit },
    { path: '/admin/department/top', component: DepartmentList },
    { path: '/admin/department/new', component: DepartmentNewEdit },
    { path: '/admin/department/edit/:id', component: DepartmentNewEdit },
    { path: '/admin/config/top', component: Config },
    { path: '/admin/config/company', component: ConfigCompany },
    { path: '/admin/config/card', component: ConfigCard },
    { path: '/admin/config/delete', component: ConfigDelete },
    { path: '/admin/config/sign-out', component: ConfigSignOut },

    // オペレータ画面
    { path: '/operator/top', component: Calendar },
    { path: '/operator/setting', component: OpeSetting},
    { path: '/operator/work/top', component: Work },
    { path: '/operator/work/edit/:targetDate', component: WorkEdit },
    { path: '/operator/leave-request/history', component: LeaveRequestHistory },
    { path: '/operator/kotsuhi/history', component: KotsuhiHistory },
    { path: '/operator/kotsuhi/unpaid', component: KotsuhiUnpaidList },

    { path: '/404', component: PageNotFound },
    { path: '*', component: PageNotFound },
  ]
})


window.onload = () => {
  createVue()
}
const createVue = () => {
  return new Vue({
    components: { 
      AsnHeader,
      AsnFooter,
      Loading,
      Tooltip,
    },
    router,
    el: '#app'
  })
}





// WEBPACK FOOTER //
// ./src/assets/js/app.js